module.exports = __webpack_public_path__ + "static/1252916139.08622306.jpg";